import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
export function MiniTroopersReviews() {
  return <section className="py-24 bg-off-white" data-id="element-2544">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2545">
        <h2 className="text-4xl text-ink text-center mb-16" data-id="element-2546">
          Parents Love Mini Troopers
        </h2>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-2547">
          <ReviewCard quote="My 4-year-old had trouble focusing, but after a few months in Mini Troopers, his preschool teacher noticed a huge difference in his listening skills." name="Amanda T." label="Parent Review" data-id="element-2548" />
          <ReviewCard quote="The coaches are incredibly patient and know exactly how to keep the little ones engaged. It's the highlight of my daughter's week." name="Marcus W." label="Parent Review" data-id="element-2549" />
          <ReviewCard quote="A perfect introduction to martial arts. They learn real skills but in a way that feels like a fun game." name="Jessica H." label="Parent Review" data-id="element-2550" />
        </div>
      </div>
    </section>;
}